import { FormControl, MenuItem, Select } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';
import NullCheckUtil from '../../util/NullCheckUtil';
import { CustomPagination, defaultTooltipRender, EmptyPagination } from '../TableBox';

export const defaultGridData = {
    rows: [],
    totalCount: 0,
    page: 0,
    pageSize: 100,
};

const GridTable = forwardRef(({ hideHeader, hidePagination, selector }, ref) => {
    const [columns, setColumns] = useState([]);
    const [onChagnePageInfo, setOnChagnePageInfo] = useState(() => {});
    const [onRowDoubleClick, setOnRowDoubleClick] = useState(() => {});
    const [onRowClick, setOnRowClick] = useState(() => {});
    const { gridData } = useSelector(selector);

    useImperativeHandle(ref, () => ({
        setColumns: setColumns,
        setChagnePageInfo: setOnChagnePageInfo,
        setRowDoubleClick: setOnRowDoubleClick,
        setRowClick: setOnRowClick,
    }));

    return (
        <div className='grid-table'>
            <div className='grid-table-body'>
                {hideHeader ? (
                    <></>
                ) : (
                    <div className='grid-table-head'>
                        <div className='head-text'>총 {NullCheckUtil.isNull(gridData) ? 0 : gridData.totalCount}건</div>
                        <div className='head-select'>
                            <div>Rows per page</div>
                            <FormControl className='grid-table-head-item' variant='outlined' size='small'>
                                <Select
                                    value={NullCheckUtil.isNull(gridData) ? 10 : gridData.pageSize}
                                    onChange={(e) => onChagnePageInfo(gridData.page, e.target.value)}
                                >
                                    {pagePerCountOptions.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                )}
                <DataGrid
                    autoHeight
                    hideFooterSelectedRowCount
                    pagination
                    page={NullCheckUtil.isNull(gridData) ? 0 : gridData.page}
                    pageSize={NullCheckUtil.isNull(gridData) ? 10 : gridData.pageSize}
                    paginationMode='server'
                    columns={columns.map((column) =>
                        column.tooltip
                            ? {
                                  ...column,
                                  renderCell: (params) => defaultTooltipRender(params, column),
                              }
                            : column,
                    )}
                    rows={NullCheckUtil.isNull(gridData) ? [] : gridData.rows}
                    rowCount={NullCheckUtil.isNull(gridData) ? 0 : gridData.totalCount}
                    onPageChange={(page) => onChagnePageInfo(page, gridData.pageSize)}
                    onRowDoubleClick={onRowDoubleClick}
                    onRowClick={onRowClick}
                    components={
                        hidePagination
                            ? {
                                  Pagination: EmptyPagination,
                              }
                            : {
                                  Pagination: CustomPagination,
                              }
                    }
                    sx={{
                        '.MuiDataGrid-columnSeparator': {
                            display: 'none',
                        },
                        '&.MuiDataGrid-root': {
                            borderLeft: 'none',
                            borderRight: 'none',
                            borderBottom: 'none',
                            fontFamily: 'inherit',
                        },
                    }}
                />
            </div>
        </div>
    );
});

export default GridTable;
